var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useState, useRef } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import useSWRImmutable from "swr/immutable";
import { process } from "../Process";
import { money } from "ee-proto-interfaces";
import { apiFetchResponse, Auth0Fetcher, Dropdown, LineGraph, LoadingIcon, SingleStat, StaticTable, StyledButton, StyledButtonStyle, TextInput, } from "ee-react-components";
import { Disclosure, Transition } from "@headlessui/react";
import { CheckIcon, ChevronDownIcon, ChevronUpIcon, } from "@heroicons/react/24/outline";
import { GetCarInformationFromEVCCID, GetDisplayPrice, GetOCPPVendorErrorDetails, INTEGRATION_TO_OCPI_DISPLAY_NAME, NumberLocaleStringStyle, PortTypeToString, protoTimestampToNative, } from "ee-utils";
import { Permission, TransactionTrackingType, } from "ee-nestjs-interfaces";
import { PowerQualityIssue } from "ee-shared-definitions";
import { useParams } from "react-router-dom";
import { BackButton } from "../Components/BackButton";
import { AlertIcon } from "../Components/Images";
import { SECONDS_TO_MS } from "../Constants";
import { usePermissions } from "../PermissionsContext";
export var RelatedTransactionsTable = function (_a) {
    var transactions = _a.transactions, title = _a.title, isNoc = _a.isNoc;
    var relatedTransactionColumns = [
        {
            id: "startTime",
            header: "Start",
            accessorFn: function (row) {
                return new Date(row.sessionStart);
            },
            cell: function (info) {
                return info.getValue().toLocaleString();
            },
            sortingFn: "datetime",
        },
        {
            header: "Duration",
            accessorFn: function (row) {
                var chargeSeconds = row
                    ? Math.round((new Date(row.sessionEnd).getTime() -
                        new Date(row.sessionStart).getTime()) /
                        1000)
                    : 0;
                var s = chargeSeconds % 60;
                var m = Math.floor(chargeSeconds / 60);
                return "".concat(m, "m ").concat(s, "s");
            },
        },
        {
            header: "Peak Power",
            accessorFn: function (row) {
                return "".concat(Number(row.peakPowerKw).toFixed(0), " kW");
            },
        },
        {
            header: "Energy Delivered",
            accessorFn: function (row) {
                return "".concat(Number(row.energyDeliveredKwh).toFixed(2), " kWh");
            },
        },
        {
            header: "Site",
            accessorKey: "siteName",
        },
        {
            header: "Total",
            accessorFn: function (row) {
                return "".concat(GetDisplayPrice(row.transactionAmount, row.transactionAmountPrecision, {
                    maximumFractionDigits: 2,
                    useLocaleString: true,
                    localeStringStyle: NumberLocaleStringStyle.Currency,
                }));
            },
        },
    ];
    if (isNoc) {
        relatedTransactionColumns.push({
            header: "Fault Code (NOC-only)",
            accessorKey: "faultCode",
        });
    }
    var initialSorting = [
        {
            id: "startTime",
            desc: false,
        },
    ];
    return (React.createElement(Disclosure, null, function (_a) {
        var open = _a.open;
        return (React.createElement(React.Fragment, null,
            React.createElement(Disclosure.Button, { className: "bg-black-1000 hover:bg-black-800 rounded-[10px] px-[32px] py-[16px] flex flex-row gap-x-[32px] mt-4 w-3/5 justify-between" },
                React.createElement("label", { className: "font-N6" }, title),
                open ? (React.createElement(ChevronDownIcon, { className: "w-[32px] h-[32px]" })) : (React.createElement(ChevronUpIcon, { className: "w-[32px] h-[32px]" }))),
            React.createElement(Disclosure.Panel, { className: "w-full" },
                React.createElement(StaticTable, { data: transactions, buildRowLink: function (row) { return "/transaction/".concat(row.transactionId); }, columnDefinitions: relatedTransactionColumns, initialSorting: initialSorting, emptyMessage: "No previous transactions." }))));
    }));
};
var PaymentDetails = function (_a) {
    var transactionId = _a.transactionId;
    var _b = useAuth0(), isAuthenticated = _b.isAuthenticated, isLoading = _b.isLoading, getAccessTokenSilently = _b.getAccessTokenSilently;
    var _c = useState(false), showDetails = _c[0], setShowDetails = _c[1];
    var details = useSWRImmutable(isLoading || !isAuthenticated || !transactionId || !showDetails
        ? null
        : [
            "".concat(process.env.CORE_SVC_URL, "/charging-sessions/attempt/paymentDetails/").concat(transactionId),
            getAccessTokenSilently,
        ], Auth0Fetcher, {
        refreshInterval: undefined,
    }).data;
    var opacityTransitionProperties = {
        enter: "transition-opacity duration-500",
        enterFrom: "opacity-0",
        enterTo: "opacity-100",
        leave: "transition-opacity duration-300",
        leaveFrom: "opacity-100",
        leaveTo: "opacity-0",
    };
    return (React.createElement("div", { className: "grid" },
        React.createElement(Transition, __assign({ className: "overlap-grid flex flex-col gap-y-4" }, opacityTransitionProperties, { show: !showDetails }),
            React.createElement(StyledButton, { text: "View Credit Card Information", onClick: function () { return setShowDetails(true); }, style: StyledButtonStyle.Gray })),
        React.createElement(Transition, __assign({ className: "overlap-grid flex flex-col gap-y-4" }, opacityTransitionProperties, { show: showDetails }),
            details == null && (React.createElement("div", { className: "h-[32px] w-[32px]" }, LoadingIcon)),
            details != null && (React.createElement(React.Fragment, null,
                React.createElement("hr", { className: "border-black-800 max-w-[275px]" }),
                React.createElement("div", { className: "flex flex-row gap-x-[32px]" },
                    React.createElement(SingleStat, { title: "Card Type", value: details.cardType }),
                    React.createElement(SingleStat, { title: "Card Number", value: details.maskedPan }),
                    React.createElement(SingleStat, { title: "Cardholder Name", value: details.customerName })))))));
};
var InsightCard = function (_a) {
    var title = _a.title, body = _a.body;
    return (React.createElement("div", { className: "flex flex-row gap-x-[16px] p-[32px] justify-center rounded-[20px] bg-black-1000 max-w-[350px]" },
        React.createElement("div", { className: "mt-[4px] w-fit" }, AlertIcon),
        React.createElement("div", { className: "flex flex-col gap-y-[16px]" },
            React.createElement("label", { className: "text-white font-N7" }, title),
            React.createElement("label", { className: "text-white font-N8p5" }, body))));
};
export var TrackingTypeComponent = function (_a) {
    var trackingType = _a.trackingType, setTrackingType = _a.setTrackingType, editing = _a.editing, setEditing = _a.setEditing, updateType = _a.updateType;
    return editing ? (React.createElement("div", { className: "flex flex-col gap-y-[8px]" },
        React.createElement("label", { className: "font-N8p5" }, "Tracking Type"),
        React.createElement(Dropdown, { items: [
                {
                    name: "None",
                    value: undefined,
                    selectedLabel: "None",
                },
                {
                    name: "Atypical Testing",
                    value: TransactionTrackingType.ATYPICAL_TESTING,
                },
                {
                    name: "Commissioning",
                    value: TransactionTrackingType.COMMISSIONING,
                },
                {
                    name: "Maintenance Window",
                    value: TransactionTrackingType.MAINTENANCE_WINDOW,
                },
                {
                    name: "Free Pricing Maintenance Window",
                    value: TransactionTrackingType.FREE_PRICING_MAINTENANCE_WINDOW,
                },
            ], onClick: setTrackingType, currentSelection: trackingType }),
        React.createElement(CheckIcon, { className: "w-[14px] h-[14px] cursor-pointer", onClick: updateType }))) : (React.createElement("div", { className: "flex flex-col gap-y-[8px]" },
        React.createElement(SingleStat, { title: "Tracking Type", value: "".concat(trackingType || "None"), editFunction: setEditing, editing: editing })));
};
export var Transaction = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y;
    var isNoc = _a.isNoc;
    var _z = useAuth0(), isAuthenticated = _z.isAuthenticated, isLoading = _z.isLoading, getAccessTokenSilently = _z.getAccessTokenSilently;
    var transactionId = useParams().transactionId;
    var startDateInput = useRef(null);
    var endDateInput = useRef(null);
    var _0 = useState(undefined), trackingType = _0[0], setTrackingType = _0[1];
    var _1 = useState(false), editing = _1[0], setEditing = _1[1];
    var permissions = usePermissions();
    var details = useSWRImmutable(isLoading || !isAuthenticated
        ? null
        : [
            "".concat(process.env.CORE_SVC_URL, "/charging-sessions/attempt/").concat(transactionId),
            getAccessTokenSilently,
        ], Auth0Fetcher, {
        refreshInterval: undefined,
    }).data;
    var chargeTime = details
        ? Math.round((new Date(details.sessionEnd).getTime() -
            new Date(details.sessionStart).getTime()) /
            1000)
        : 0;
    var secondsToDisplayTime = function (seconds) {
        var chargeSeconds = seconds % 60;
        var chargeMinutes = Math.floor(seconds / 60);
        var displayTime = seconds == 0 ? "--" : "";
        if (chargeMinutes > 0) {
            displayTime = "".concat(chargeMinutes, " minute").concat(chargeMinutes == 1 ? "" : "s", " ");
        }
        if (chargeSeconds > 0) {
            displayTime = "".concat(displayTime).concat(chargeSeconds, " second").concat(chargeSeconds == 1 ? "" : "s");
        }
        return displayTime;
    };
    var secondsToGraphDisplayTime = function (seconds) {
        var chargeSeconds = seconds % 60;
        var chargeMinutes = Math.floor(seconds / 60);
        return "".concat(chargeMinutes, "m ").concat(chargeSeconds, "s");
    };
    var displayTime = secondsToDisplayTime(chargeTime);
    if (!details) {
        return React.createElement("div", null);
    }
    var hasDetails = details.details && details.details.length > 0;
    if (hasDetails &&
        details.trackingType != undefined &&
        trackingType == undefined) {
        setTrackingType(details.trackingType);
    }
    var socDifference = hasDetails
        ? Number(details.details[details.details.length - 1].SoC) -
            Number((_b = details.details.find(function (detail) { return detail.SoC > 0; })) === null || _b === void 0 ? void 0 : _b.SoC)
        : 0;
    var startTime = hasDetails
        ? new Date(details.details[0].detailTime).getTime() / 1000
        : new Date(details.sessionStart).getTime() / 1000;
    var hasPowerRequest = false;
    var powerGraphData = hasDetails
        ? details.details.map(function (detail) {
            if (detail.powerRequestKW > 0) {
                hasPowerRequest = true;
            }
            return {
                power: Math.max(0, detail.powerKW),
                limit: Math.max(0, detail.powerLimitKW),
                request: Math.max(0, detail.powerRequestKW),
                time: new Date(detail.detailTime).getTime() / 1000 - startTime,
            };
        })
        : [];
    var deliveredEnergyData = hasDetails
        ? details.details.map(function (detail) {
            return {
                energy: detail.totalEnergyDelivered,
                soc: detail.SoC,
                time: new Date(detail.detailTime).getTime() / 1000 - startTime,
            };
        })
        : [];
    var hasLowRateDetails = isNoc && details.lowRateDetails && details.lowRateDetails.length > 0;
    var powerDiagnosticsLabelAccesor = function (d) {
        return "".concat(secondsToGraphDisplayTime(d.time));
    };
    var powerDiagnosticsValueAccessors = [
        {
            label: "Power",
            accessor: function (d) { return d.power; },
        },
        {
            label: "Power Limit",
            accessor: function (d) { return d.powerLimit; },
        },
        {
            label: "EV Max Power",
            accessor: function (d) { return d.evMaxPower; },
        },
    ];
    var powerDiagnosticsGraphData = hasLowRateDetails
        ? details.lowRateDetails.map(function (detail) {
            return {
                power: Math.max(0, detail.powerKW),
                powerLimit: Math.max(0, detail.powerLimitKW),
                evMaxPower: Math.max(0, detail.evMaxPower),
                time: new Date(detail.detailTime).getTime() / 1000 - startTime,
            };
        })
        : [];
    var voltageDiagnosticsLabelAccesor = function (d) {
        return "".concat(secondsToGraphDisplayTime(d.time));
    };
    var voltageDiagnosticsValueAccessors = [
        {
            label: "Voltage",
            accessor: function (d) { return d.voltage; },
        },
        {
            label: "EV Max Voltage",
            accessor: function (d) { return d.evMaxVoltage; },
        },
        {
            label: "EVSE Max Voltage",
            accessor: function (d) { return d.evseMaxVoltage; },
        },
        {
            label: "EV Target Voltage",
            accessor: function (d) { return d.evTargetVoltage; },
        },
    ];
    var voltageDiagnosticsGraphData = hasLowRateDetails
        ? details.lowRateDetails.map(function (detail) {
            return {
                voltage: Math.max(0, detail.voltage),
                evMaxVoltage: Math.max(0, detail.evMaxVoltage),
                evseMaxVoltage: Math.max(0, detail.evseMaxVoltage),
                evTargetVoltage: Math.max(0, detail.evTargetVoltage),
                time: new Date(detail.detailTime).getTime() / 1000 - startTime,
            };
        })
        : [];
    var currentDiagnosticsLabelAccesor = function (d) {
        return "".concat(secondsToGraphDisplayTime(d.time));
    };
    var currentDiagnosticsValueAccessors = [
        {
            label: "Current",
            accessor: function (d) { return d.current; },
        },
        {
            label: "EV Max Current",
            accessor: function (d) { return d.evMaxCurrent; },
        },
        {
            label: "EVSE Max Current",
            accessor: function (d) { return d.evseMaxCurrent; },
        },
        {
            label: "EV Target Current",
            accessor: function (d) { return d.evTargetCurrent; },
        },
    ];
    var currentDiagnosticsGraphData = hasLowRateDetails
        ? details.lowRateDetails.map(function (detail) {
            return {
                current: Math.max(0, detail.current),
                evMaxCurrent: Math.max(0, detail.evMaxCurrent),
                evseMaxCurrent: Math.max(0, detail.evseMaxCurrent),
                evTargetCurrent: Math.max(0, detail.evTargetCurrent),
                time: new Date(detail.detailTime).getTime() / 1000 - startTime,
            };
        })
        : [];
    var socDiagnosticsLabelAccesor = function (d) { return "".concat(d.time, "s"); };
    var socDiagnosticsValueAccessors = [
        {
            label: "SoC",
            accessor: function (d) { return d.soc; },
        },
        {
            label: "Time to Bulk SoC",
            accessor: function (d) { return d.timeToBulkSoc; },
            secondAxis: true,
        },
        {
            label: "Time to Full SoC",
            accessor: function (d) { return d.timeToFullSoc; },
            secondAxis: true,
        },
    ];
    var socDiagnosticsGraphData = hasLowRateDetails
        ? details.lowRateDetails.map(function (detail) {
            return {
                soc: Math.max(0, detail.SoC),
                timeToBulkSoc: Math.max(0, detail.timeToBulkSoc),
                timeToFullSoc: Math.max(0, detail.timeToFullSoc),
                time: new Date(detail.detailTime).getTime() / 1000 - startTime,
            };
        })
        : [];
    var sessionInsights = [];
    if ((details === null || details === void 0 ? void 0 : details.faultCode) != null) {
        var errorDetails = GetOCPPVendorErrorDetails(details.faultCode);
        if (errorDetails) {
            sessionInsights.push([
                "Session Faulted",
                errorDetails.commandConsoleDescription,
            ]);
        }
    }
    if (isNoc && (details === null || details === void 0 ? void 0 : details.faultCode) != null) {
        sessionInsights.push([
            "NOC Fault Details",
            "Vendor error code: ".concat(details === null || details === void 0 ? void 0 : details.faultCode),
        ]);
    }
    var powerLabelAccesor = function (d) {
        return "".concat(secondsToGraphDisplayTime(d.time));
    };
    var powerValueAccessors = [
        {
            label: "Power",
            accessor: function (d) { return d.power; },
        },
        {
            label: "Power Limit",
            accessor: function (d) { return d.limit; },
        },
    ];
    if (hasPowerRequest) {
        powerValueAccessors.push({
            label: "Vehicle Request",
            accessor: function (d) { return d.request; },
        });
    }
    var energyLabelAccesor = function (d) {
        return "".concat(secondsToGraphDisplayTime(d.time));
    };
    var energyValueAccessors = [
        {
            label: "Car Battery %",
            accessor: function (d) { return d.soc; },
        },
        {
            label: "Energy Delivered",
            accessor: function (d) { return d.energy; },
            secondAxis: true,
        },
    ];
    var currentLabelAccesor = function (d) {
        return "".concat(secondsToGraphDisplayTime(d.time));
    };
    var currentValueAccessors = [
        {
            label: "Current",
            accessor: function (d) { return d.current; },
        },
        {
            label: "Voltage",
            accessor: function (d) { return d.voltage; },
            secondAxis: true,
        },
    ];
    var currentData = [];
    if (isNoc && hasDetails && details.details) {
        currentData = details.details
            .map(function (d) {
            if (d.current == null || d.voltage == null) {
                return null;
            }
            return {
                current: d.current,
                voltage: d.voltage,
                time: new Date(d.detailTime).getTime() / 1000 - startTime,
            };
        })
            .filter(function (d) { return d; });
    }
    var authorizationTypeToString = function (authorizationType) {
        if (authorizationType == null) {
            return null;
        }
        switch (authorizationType) {
            case money.PaymentAuthorizationType.AUTHORIZATION_TYPE_CARD_PRESENT:
                return "CARD PRESENT";
            case money.PaymentAuthorizationType
                .AUTHORIZATION_TYPE_CARD_PRESENT_OFFLINE:
                return isNoc ? "CARD PRESENT/OFFLINE" : "CARD PRESENT";
            case money.PaymentAuthorizationType.AUTHORIZATION_TYPE_CARD_PRESENT_PHONE:
                return "PHONE PAYMENT";
            case money.PaymentAuthorizationType
                .AUTHORIZATION_TYPE_REMOTE_AUTHORIZED_COMMAND_CONSOLE:
                return "COMMAND CONSOLE";
            case money.PaymentAuthorizationType
                .AUTHORIZATION_TYPE_REMOTE_AUTHORIZED_OCPI:
                return "OCPI [REMOTE AUTH]";
            case money.PaymentAuthorizationType
                .AUTHORIZATION_TYPE_RFID_AUTHORIZED_OCPI:
                return "OCPI [RFID CARD]";
        }
        return null;
    };
    var authorizationTypeString = authorizationTypeToString(details === null || details === void 0 ? void 0 : details.authorizationType);
    var authorizationStatusToString = function (authorizationStatus) {
        if (authorizationStatus == null) {
            return null;
        }
        switch (authorizationStatus) {
            case money.PaymentAuthorizationStatus.AUTHORIZATION_STATUS_UNKNOWN:
                return "Unknown (Likely N/A)";
            case money.PaymentAuthorizationStatus.AUTHORIZATION_STATUS_PENDING:
                return "Pending";
            case money.PaymentAuthorizationStatus
                .AUTHORIZATION_STATUS_COMPLETED_SUCCESSFULLY:
                return "Successful";
            case money.PaymentAuthorizationStatus
                .AUTHORIZATION_STATUS_COMPLETED_FAILED_MAX_RETRIES:
                return "Failed with too many attempts";
            case money.PaymentAuthorizationStatus
                .AUTHORIZATION_STATUS_COMPLETED_FAILED_VOIDED:
                return "Failed with a voided response";
            case money.PaymentAuthorizationStatus
                .AUTHORIZATION_STATUS_COMPLETED_FAILED_DECLINED:
                return "Failed with a decline response";
        }
        return null;
    };
    var freeReasonToString = function (freeReason) {
        if (freeReason == null) {
            return "None";
        }
        switch (freeReason) {
            case money.FreeReason.NOT_APPLICABLE:
                return "Not Applicable";
            case money.FreeReason.SUPPORT_AGENT_FREE_SESSION:
                return "Support Agent Free Session";
            case money.FreeReason.FREE_MODE:
                return "Free Mode";
            case money.FreeReason.FORCE_START_TRANSACTIONS:
                return "Transaction Force Started";
            case money.FreeReason.NO_ENERGY_DISPENSED:
                return "No Energy Dispensed";
            case money.FreeReason.UNABLE_TO_CALCULATE_ENERGY_DISPENSED:
                return "Unable to Calculate Energy Dispensed";
            case money.FreeReason.NO_PAYMENT_DEVICE:
                return "No Payment Device";
            case money.FreeReason.FAILED_TO_PROCESS_SALE:
                return "Failed to Process Sale";
            case money.FreeReason.UNKNOWN:
                return "Unknown";
            default:
                return String(freeReason);
        }
    };
    var authorizationStatusString = authorizationStatusToString(details === null || details === void 0 ? void 0 : details.authorizationStatus);
    var taxes = (_e = (_d = (_c = details === null || details === void 0 ? void 0 : details.chargeBreakdown) === null || _c === void 0 ? void 0 : _c.surcharges) === null || _d === void 0 ? void 0 : _d.filter(function (s) { var _a; return ((_a = s.charge) === null || _a === void 0 ? void 0 : _a.type) == money.SurchargeType.SURCHARGE_TAX; })) !== null && _e !== void 0 ? _e : [];
    var totalTaxAmount = (_f = taxes.reduce(function (a, c) { var _a, _b; return a + ((_b = (_a = c.amount) === null || _a === void 0 ? void 0 : _a.amount) !== null && _b !== void 0 ? _b : 0); }, 0)) !== null && _f !== void 0 ? _f : 0;
    var taxAuthorities = taxes.map(function (t) {
        var _a, _b, _c, _d;
        return "".concat((_b = (_a = t.charge) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : "Tax", " (").concat((((_d = (_c = t.charge) === null || _c === void 0 ? void 0 : _c.percentage) !== null && _d !== void 0 ? _d : 0) * 100).toFixed(3), "%)");
    });
    var carInformation = (details === null || details === void 0 ? void 0 : details.evccid) != null && details.evccid != ""
        ? GetCarInformationFromEVCCID(details.evccid)
        : undefined;
    var formatDateTimeLocal = function (date) {
        var pad = function (n) { return n.toString().padStart(2, "0"); };
        return "".concat(date.getFullYear(), "-").concat(pad(date.getMonth() + 1), "-").concat(pad(date.getDate()), "T").concat(pad(date.getHours()), ":").concat(pad(date.getMinutes()));
    };
    var handleAdjustTime = function (inputRef, minutes) {
        if (inputRef.current) {
            var newTime = adjustTime(inputRef.current.value, minutes);
            inputRef.current.value = newTime;
        }
    };
    var adjustTime = function (dateString, minutes) {
        var date = new Date(dateString);
        date.setMinutes(date.getMinutes() + minutes);
        return formatDateTimeLocal(date);
    };
    var sessionStart = details ? new Date(details.sessionStart) : undefined;
    var sessionEnd = details ? new Date(details.sessionEnd) : undefined;
    var plugIn = (details === null || details === void 0 ? void 0 : details.plugInUtc) ? new Date(details.plugInUtc) : undefined;
    var unplug = (details === null || details === void 0 ? void 0 : details.unplugUtc) ? new Date(details.unplugUtc) : undefined;
    var telemetryLinkBuffer = 10 * SECONDS_TO_MS;
    var telemetryLinkFrom = plugIn
        ? plugIn.getTime() - telemetryLinkBuffer
        : undefined;
    var telemetryLinkTo = unplug
        ? unplug.getTime() + telemetryLinkBuffer
        : "now";
    var isEEv3 = (_g = details === null || details === void 0 ? void 0 : details.chargerModel) === null || _g === void 0 ? void 0 : _g.toLowerCase().startsWith("eev3");
    // Builds a time-scoped Grafana URL by setting from/to and any extra params on the base dashboard URL.
    var buildGrafanaUrl = function (baseUrl, pnId, setParams) {
        var url = new URL("".concat(baseUrl).concat(pnId));
        url.searchParams.set("from", String(telemetryLinkFrom));
        url.searchParams.set("to", String(telemetryLinkTo));
        setParams === null || setParams === void 0 ? void 0 : setParams(url.searchParams);
        return url.toString();
    };
    var fetchLogs = function (transactionId, startTime, endTime) { return __awaiter(void 0, void 0, void 0, function () {
        var query, filename, getToken, response, blob, url, link, err_1;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    query = "".concat(process.env.NOC_SVC_URL, "/logs/transaction/download/").concat(transactionId, "?start=").concat(startTime, "&end=").concat(endTime);
                    filename = "download.zip";
                    getToken = function () {
                        return getAccessTokenSilently({
                            authorizationParams: {
                                audience: process.env.AUTH0_AUDIENCE,
                            },
                        });
                    };
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 4, , 5]);
                    return [4 /*yield*/, apiFetchResponse(query, {
                            method: "GET",
                            callbacks: {
                                getToken: getToken,
                            },
                        })];
                case 2:
                    response = _c.sent();
                    if (!response.ok) {
                        throw new Error("HTTP error! Status: ".concat(response.status));
                    }
                    filename =
                        ((_b = (_a = response.headers
                            .get("Content-Disposition")) === null || _a === void 0 ? void 0 : _a.match(/filename="([^"]+)"/)) === null || _b === void 0 ? void 0 : _b[1]) || filename;
                    return [4 /*yield*/, response.blob()];
                case 3:
                    blob = _c.sent();
                    url = window.URL.createObjectURL(blob);
                    link = document.createElement("a");
                    link.href = url;
                    link.setAttribute("download", filename);
                    link.click();
                    window.URL.revokeObjectURL(url);
                    return [3 /*break*/, 5];
                case 4:
                    err_1 = _c.sent();
                    console.error("Error fetching logs:", err_1);
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var updateType = function () { return __awaiter(void 0, void 0, void 0, function () {
        var accessToken, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getAccessTokenSilently({
                        authorizationParams: {
                            audience: process.env.AUTH0_AUDIENCE,
                        },
                    })];
                case 1:
                    accessToken = _a.sent();
                    return [4 /*yield*/, fetch("".concat(process.env.NOC_SVC_URL, "/transactions/transaction/").concat(details.transactionId), {
                            method: "PATCH",
                            headers: {
                                "Content-Type": "application/json",
                                authorization: "Bearer ".concat(accessToken),
                            },
                            body: JSON.stringify({ trackingType: trackingType }),
                        })];
                case 2:
                    response = _a.sent();
                    if (response.ok) {
                        setEditing(false);
                        details.trackingType = trackingType;
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    return (React.createElement("div", { className: "flex flex-col pl-[32px]" },
        React.createElement(BackButton, null),
        React.createElement("label", { className: "font-N5 text-white mt-[64px]" }, "Session Details"),
        details && (React.createElement("label", { className: "font-N8 text-black-400 mt-[4px]" }, "".concat(sessionStart === null || sessionStart === void 0 ? void 0 : sessionStart.toLocaleString()))),
        React.createElement("div", { className: "grid grid-cols-3 mt-[64px] gap-x-[32px] gap-y-[32px] w-fit" },
            React.createElement(SingleStat, { title: "Transaction Amount", value: "".concat(GetDisplayPrice((_h = details === null || details === void 0 ? void 0 : details.transactionAmount) !== null && _h !== void 0 ? _h : 0, (_j = details === null || details === void 0 ? void 0 : details.transactionAmountPrecision) !== null && _j !== void 0 ? _j : 2, {
                    maximumFractionDigits: 2,
                    useLocaleString: true,
                    localeStringStyle: NumberLocaleStringStyle.Currency,
                })) }),
            React.createElement(SingleStat, { title: "Peak Power", value: "".concat(Number(details === null || details === void 0 ? void 0 : details.peakPowerKw).toFixed(2), " kW") }),
            React.createElement(SingleStat, { title: "Energy Delivered", value: "".concat(Number(details === null || details === void 0 ? void 0 : details.energyDeliveredKwh).toFixed(2), " kWh") }),
            React.createElement(SingleStat, { title: "Total Charge Time", value: "".concat(displayTime) }),
            React.createElement(SingleStat, { title: "Vehicle Battery Level", value: "+".concat(socDifference, "%") }),
            isNoc && React.createElement(SingleStat, { title: "Port ID", value: "".concat(details === null || details === void 0 ? void 0 : details.portId) }),
            React.createElement(SingleStat, { title: "Plug", value: PortTypeToString(details === null || details === void 0 ? void 0 : details.portType) }),
            React.createElement(SingleStat, { title: "Authorization Type", value: authorizationTypeString !== null && authorizationTypeString !== void 0 ? authorizationTypeString : "Undefined" }),
            React.createElement(SingleStat, { title: "Third Party Source", value: (_k = INTEGRATION_TO_OCPI_DISPLAY_NAME.get(details === null || details === void 0 ? void 0 : details.emspName)) !== null && _k !== void 0 ? _k : "Not Applicable" }),
            isNoc && (React.createElement(React.Fragment, null,
                authorizationStatusString && (React.createElement(SingleStat, { title: "Authorization Status (NOC-only)", value: authorizationStatusString })),
                React.createElement(SingleStat, { title: "Free reason (NOC-only)", value: freeReasonToString(details.freeReason) }),
                React.createElement(SingleStat, { title: "Charging Session Start UTC (NOC-only)", value: sessionStart === null || sessionStart === void 0 ? void 0 : sessionStart.toUTCString() }),
                React.createElement(SingleStat, { title: "Charging Session End UTC (NOC-only)", value: sessionEnd === null || sessionEnd === void 0 ? void 0 : sessionEnd.toUTCString() }),
                React.createElement(SingleStat, { title: "Organization Name (NOC-only)", value: details.organizationName }),
                React.createElement(SingleStat, { title: "Site Name (NOC-only)", value: details.siteName }),
                React.createElement(SingleStat, { title: "Site ID (NOC-only)", value: details.siteId.toString() }),
                React.createElement(SingleStat, { title: "Unique Ref (NOC-only)", value: details.uniqueReference }),
                React.createElement(SingleStat, { title: "Totalizer End (NOC-only)", value: "".concat(Number((_l = details.totalizerEnd) !== null && _l !== void 0 ? _l : 0).toFixed(2), " kWh") }),
                React.createElement(SingleStat, { title: "EVCCID (NOC-only)", value: "".concat((_m = details.evccid) !== null && _m !== void 0 ? _m : "Unknown") }),
                React.createElement(SingleStat, { title: "Friendly ID (NOC-only)", value: details.chargerFriendlyId }),
                React.createElement(SingleStat, { title: "Serial Number (NOC-only)", value: (_o = details.chargerSerialNumber) !== null && _o !== void 0 ? _o : "N/A" }),
                details.stopReason != null && (React.createElement(SingleStat, { title: "Stop Reason (NOC-only)", value: details.stopReason, helpText: "The reason reported by the charger for stopping the transaction" })),
                details.faultCode != null && (React.createElement(SingleStat, { title: "Fault Code (NOC-only)", value: details.faultCode, helpText: "The fault code reported by the charger." })),
                details.finishCode != null && (React.createElement(SingleStat, { title: "Finish Code (NOC-only)", value: details.finishCode, helpText: "The finish code reported by the charger firmware at the end of the session." })),
                details.powerQualityIssues != null &&
                    details.powerQualityIssues.length > 0 && (React.createElement(SingleStat, { title: "Power Quality Issues (NOC-only)", value: details.powerQualityIssues
                        .map(function (i) { return PowerQualityIssue[i]; })
                        .join(", "), helpText: "Power quality issues that caused derating during this session." })),
                details.timePowerLimitedMs != null && (React.createElement(SingleStat, { title: "Time Power Limited (NOC-only)", value: secondsToDisplayTime(Math.round(details.timePowerLimitedMs / 1000)), helpText: "Total time during the session when charging was power limited." })),
                (carInformation === null || carInformation === void 0 ? void 0 : carInformation.manufacturer) != null && (React.createElement(SingleStat, { title: "Equipment Mfr.", value: carInformation.manufacturer, helpText: "The manufacturer of the charging equipment. Not always the same as the car's manufacturer, as the car manufacturer may outsource the component." })),
                (carInformation === null || carInformation === void 0 ? void 0 : carInformation.suspectedCarManufacturers) != null && (React.createElement(SingleStat, { title: "Suspected Car Manufacturer", value: carInformation.suspectedCarManufacturers.join(", "), helpText: "Car manufacturers we suspect (but have not confirmed) may work with the equipment manufacturer." })),
                (carInformation === null || carInformation === void 0 ? void 0 : carInformation.confirmedCarManufacturers) != null && (React.createElement(SingleStat, { title: "Confirmed Car Manufacturer", value: carInformation.confirmedCarManufacturers.join(", "), helpText: "Car manufacturers we've confirmed use this equipment." })),
                (carInformation === null || carInformation === void 0 ? void 0 : carInformation.confirmedCars) != null && (React.createElement(SingleStat, { title: "Confirmed Cars", value: carInformation.confirmedCars.join(", "), helpText: "Cars we've confirmed to match this EVCCID pattern." })),
                React.createElement(SingleStat, { title: "Plug-In UTC (NOC-only)", value: plugIn === null || plugIn === void 0 ? void 0 : plugIn.toUTCString() }),
                React.createElement(SingleStat, { title: "Unplug UTC (NOC-only)", value: unplug === null || unplug === void 0 ? void 0 : unplug.toUTCString() }))),
            isNoc && (React.createElement(TrackingTypeComponent, { editing: editing, setEditing: setEditing, trackingType: trackingType, setTrackingType: setTrackingType, updateType: updateType }))),
        isNoc && details.powernodeId != null && (React.createElement("div", { className: "flex flex-col gap-y-[16px] mt-[64px]" },
            React.createElement("label", { className: "font-N6 text-white" }, "Telemetry (NOC-only)"),
            React.createElement("div", { className: "flex flex-col gap-y-[8px]" },
                React.createElement("a", { href: buildGrafanaUrl(process.env.CHARGER_DASHBOARD_URL, details.powernodeId, function (p) {
                        p.set("var-OcppId", details.chargerOcppId);
                        p.set("var-port", String(details.portId - 1));
                    }), target: "_blank", className: "font-N7 text-navy-gradient-to" }, "Charger Dashboard"),
                React.createElement("a", { href: buildGrafanaUrl(process.env.PN_DASHBOARD_URL, details.powernodeId), target: "_blank", className: "font-N7 text-navy-gradient-to" }, "Powernode Dashboard"),
                React.createElement("a", { href: buildGrafanaUrl(process.env.PN_LOGS_DASHBOARD_URL, details.powernodeId), target: "_blank", className: "font-N7 text-navy-gradient-to" }, "Powernode Logs"),
                isEEv3 && (React.createElement("a", { href: buildGrafanaUrl(process.env.PILOT_DASHBOARD_URL, details.powernodeId, function (p) {
                        p.set("var-ChargerId", details.chargerOcppId);
                    }), target: "_blank", className: "font-N7 text-navy-gradient-to" }, "RetailEdge Dashboard"))))),
        details.chargeBreakdown != null && (React.createElement("div", { className: "flex flex-col gap-y-[32px] mt-[64px]" },
            React.createElement("label", { className: "mt-[64px] font-N6 text-white" }, "Payment Breakdown"),
            React.createElement("div", { className: "grid grid-cols-3 gap-x-[32px] gap-y-[32px] w-fit" },
                React.createElement(SingleStat, { title: "Energy Cost", value: "".concat(GetDisplayPrice((_p = details === null || details === void 0 ? void 0 : details.chargeBreakdown.baseCharge) === null || _p === void 0 ? void 0 : _p.amount, (_q = details === null || details === void 0 ? void 0 : details.chargeBreakdown.baseCharge) === null || _q === void 0 ? void 0 : _q.precision, {
                        maximumFractionDigits: 2,
                        useLocaleString: true,
                        localeStringStyle: NumberLocaleStringStyle.Currency,
                    })) }),
                details.chargeBreakdown.idleFeesAfterChargingStarts != null && (React.createElement(SingleStat, { title: "Long Session Fee", value: "".concat(GetDisplayPrice((_s = (_r = details === null || details === void 0 ? void 0 : details.chargeBreakdown.idleFeesAfterChargingStarts) === null || _r === void 0 ? void 0 : _r.amount) === null || _s === void 0 ? void 0 : _s.amount, (_u = (_t = details === null || details === void 0 ? void 0 : details.chargeBreakdown.idleFeesAfterChargingStarts) === null || _t === void 0 ? void 0 : _t.amount) === null || _u === void 0 ? void 0 : _u.precision, {
                        maximumFractionDigits: 2,
                        useLocaleString: true,
                        localeStringStyle: NumberLocaleStringStyle.Currency,
                    })), helpText: "Long session fees are assessed to incentivize turnover.".concat((function () {
                        var startTime = protoTimestampToNative(details.chargeBreakdown.idleFeesAfterChargingStarts
                            .timeBeginUtc);
                        var endTime = protoTimestampToNative(details.chargeBreakdown.idleFeesAfterChargingStarts
                            .timeEndUtc);
                        return startTime && endTime
                            ? " The long session fee for this session began at ".concat(startTime.toLocaleTimeString(), " and ended at ").concat(endTime.toLocaleTimeString(), ".")
                            : "";
                    })(), " This can be configured per-station in Command Console.") })),
                details.chargeBreakdown.idleFeesAfterChargingEnds != null && (React.createElement(SingleStat, { title: "Idle Fee", value: "$".concat(GetDisplayPrice((_w = (_v = details === null || details === void 0 ? void 0 : details.chargeBreakdown.idleFeesAfterChargingEnds) === null || _v === void 0 ? void 0 : _v.amount) === null || _w === void 0 ? void 0 : _w.amount, (_y = (_x = details === null || details === void 0 ? void 0 : details.chargeBreakdown.idleFeesAfterChargingEnds) === null || _x === void 0 ? void 0 : _x.amount) === null || _y === void 0 ? void 0 : _y.precision)), helpText: "Idle fees are assessed to encourage customers to quickly unplug after their session ends.".concat((function () {
                        var startTime = protoTimestampToNative(details.chargeBreakdown.idleFeesAfterChargingEnds
                            .timeBeginUtc);
                        var endTime = protoTimestampToNative(details.chargeBreakdown.idleFeesAfterChargingEnds
                            .timeEndUtc);
                        return startTime && endTime
                            ? " The idle fee for this session began at ".concat(startTime.toLocaleTimeString(), " and ended at ").concat(endTime.toLocaleTimeString(), ".")
                            : "";
                    })(), " This can be configured per-station in Command Console.") })),
                totalTaxAmount > 0 && (React.createElement(SingleStat, { title: "Tax", value: "$".concat(GetDisplayPrice(totalTaxAmount, 2)), helpText: "Tax Authorities:", helpDetails: taxAuthorities })),
                React.createElement(SingleStat, { title: "Total", value: "$".concat(GetDisplayPrice(details === null || details === void 0 ? void 0 : details.transactionAmount, details === null || details === void 0 ? void 0 : details.transactionAmountPrecision)) })),
            (details === null || details === void 0 ? void 0 : details.uniqueReference) != null &&
                (details === null || details === void 0 ? void 0 : details.uniqueReference) != "" && (React.createElement(PaymentDetails, { transactionId: transactionId })))),
        isNoc &&
            details.relatedTransactionsByPayment &&
            details.relatedTransactionsByPayment.length > 0 && (React.createElement(RelatedTransactionsTable, { transactions: details.relatedTransactionsByPayment, title: "Transactions with Same Payment (NOC-only)", isNoc: isNoc })),
        details.relatedTransactionsByEVCCID &&
            details.relatedTransactionsByEVCCID.length > 0 && (React.createElement(RelatedTransactionsTable, { transactions: details.relatedTransactionsByEVCCID, title: "Transactions with Same Vehicle", isNoc: isNoc })),
        sessionInsights.length > 0 && (React.createElement("div", { className: "flex flex-row gap-x-[32px] my-[64px]" }, sessionInsights.map(function (s, i) { return (React.createElement(InsightCard, { key: i, title: s[0], body: s[1] })); }))),
        permissions.hasPermission(Permission.READ_TRANSACTION_LOGS) && (React.createElement("div", { className: "flex flex-col gap-y-[32px]" },
            React.createElement("label", { className: "mt-[64px] font-N6 text-white" }, "Select Time Range"),
            React.createElement("div", { className: "flex items-center gap-x-[8px]" },
                React.createElement("button", { onClick: function () { return handleAdjustTime(startDateInput, -5); } }, "-5 min"),
                React.createElement(TextInput, { type: "datetime-local", ref: startDateInput, defaultValue: sessionStart
                        ? formatDateTimeLocal(new Date(sessionStart.getTime() - 10 * SECONDS_TO_MS))
                        : "" }),
                React.createElement("button", { onClick: function () { return handleAdjustTime(startDateInput, 5); } }, "+5 min")),
            React.createElement("div", { className: "flex items-center gap-x-[8px]" },
                React.createElement("button", { onClick: function () { return handleAdjustTime(endDateInput, -5); } }, "-5 min"),
                React.createElement(TextInput, { type: "datetime-local", ref: endDateInput, defaultValue: sessionEnd
                        ? formatDateTimeLocal(new Date(sessionEnd.getTime() + 10 * SECONDS_TO_MS))
                        : "" }),
                React.createElement("button", { onClick: function () { return handleAdjustTime(endDateInput, 5); } }, "+5 min")),
            React.createElement(StyledButton, { text: "Download Logs", onClick: function () {
                    var _a, _b;
                    return fetchLogs(details.transactionId, ((_a = startDateInput.current) === null || _a === void 0 ? void 0 : _a.value)
                        ? new Date(startDateInput.current.value).toISOString()
                        : undefined, ((_b = endDateInput.current) === null || _b === void 0 ? void 0 : _b.value)
                        ? new Date(endDateInput.current.value).toISOString()
                        : undefined);
                }, disabled: false }))),
        hasDetails && (React.createElement("div", { className: "w-[75%] mt-[64px] gap-y-[128px]" },
            React.createElement(LineGraph, { title: "Session Power", labelAccessor: powerLabelAccesor, valueAccessors: powerValueAccessors, data: powerGraphData, yAxisValueToLabel: function (v) { return "".concat(v.toFixed(1), " kW"); } }),
            React.createElement("div", { className: "h-[64px]" }),
            React.createElement(LineGraph, { title: "Session Energy", labelAccessor: energyLabelAccesor, valueAccessors: energyValueAccessors, data: deliveredEnergyData, yAxisValueToLabel: function (v) { return "".concat(v, "%"); }, secondYAxisValueToLabel: function (v) { return "".concat(v.toFixed(1), " kWh"); } }),
            React.createElement("div", { className: "h-[64px]" }),
            isNoc && (React.createElement(React.Fragment, null,
                " ",
                React.createElement(LineGraph, { title: "NOC Current/Voltage", labelAccessor: currentLabelAccesor, valueAccessors: currentValueAccessors, data: currentData, yAxisValueToLabel: function (v) { return "".concat(v.toFixed(1), " A"); }, secondYAxisValueToLabel: function (v) { return "".concat(v.toFixed(1), " V"); } }),
                React.createElement("div", { className: "h-[64px]" }))))),
        hasLowRateDetails && (React.createElement("div", { className: "w-[75%] mt-[64px] gap-y-[128px]" },
            React.createElement(LineGraph, { title: "Power Diagnostics", labelAccessor: powerDiagnosticsLabelAccesor, valueAccessors: powerDiagnosticsValueAccessors, data: powerDiagnosticsGraphData, yAxisValueToLabel: function (v) { return "".concat(v.toFixed(1), " kW"); } }),
            React.createElement("div", { className: "h-[64px]" }),
            React.createElement(LineGraph, { title: "Voltage Diagnostics", labelAccessor: voltageDiagnosticsLabelAccesor, valueAccessors: voltageDiagnosticsValueAccessors, data: voltageDiagnosticsGraphData, yAxisValueToLabel: function (v) { return "".concat(v.toFixed(1), " V"); } }),
            React.createElement("div", { className: "h-[64px]" }),
            React.createElement(LineGraph, { title: "Current Diagnostics", labelAccessor: currentDiagnosticsLabelAccesor, valueAccessors: currentDiagnosticsValueAccessors, data: currentDiagnosticsGraphData, yAxisValueToLabel: function (v) { return "".concat(v.toFixed(1), " A"); } }),
            React.createElement("div", { className: "h-[64px]" }),
            React.createElement(LineGraph, { title: "SoC Diagnostics", labelAccessor: socDiagnosticsLabelAccesor, valueAccessors: socDiagnosticsValueAccessors, data: socDiagnosticsGraphData, yAxisValueToLabel: function (v) { return "".concat(v.toFixed(1), "%"); }, secondYAxisValueToLabel: function (v) { return "".concat(v, " s"); } })))));
};
